import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-layout';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        {
          key: 'Go-admin Pro',
          title: 'Go-admin Pro',
          href: 'https://github.com/go-admin-team/go-admin',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: 'https://github.com/go-admin-team/go-admin',
          blankTarget: true,
        },
        {
          key: 'Go-admin',
          title: 'Go-admin',
          href: 'https://preview.go-admin.dev/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
